import { LOGOS } from "@/data/content";
import { Kicker } from "@/components/site/Reveal";

export const Slide = ({ n, total, bg = "bg-[var(--cream)]", dark = false, className = "", children, testid }) => (
  <section data-testid={testid} className={`slide felt ${bg} ${dark ? "text-white" : "text-[var(--ink)]"} ${className}`}>
    <div className="relative z-10 flex h-full flex-col justify-center px-16 pb-16 pt-12">{children}</div>
    <footer className={`absolute bottom-6 left-16 right-16 z-10 flex items-center justify-between text-[11px] ${dark ? "text-white/60" : "text-[var(--ink)]/50"}`}>
      <span className="font-mono-label uppercase tracking-[0.2em]">Pedro Clube Show · Porto Alegre, RS</span>
      <span className="flex items-center gap-3">
        <img src={LOGOS.show} alt="" className="h-7 w-auto" />
        <span className="font-mono-label">
          {String(n).padStart(2, "0")} / {String(total).padStart(2, "0")}
        </span>
      </span>
    </footer>
  </section>
);

export const SlideTitle = ({ kicker, children, dark = false, className = "" }) => (
  <header className={className}>
    <Kicker className={dark ? "text-white/80" : "text-[var(--ink)]/70"}>{kicker}</Kicker>
    <h2 className="font-display mt-2 text-6xl font-extrabold leading-[0.95]">{children}</h2>
  </header>
);
